import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import MetaTags from '../MetaTags/MetaTags';
import "./About.css";


const About = () => {
  const faqs = [
    {
      question: "מאיפה אתה מביא את השאלות שאתה פותר?",
      answer: "מאתרים באינטרנט. מלא מהשאלות מהאתר leetcode."
    },
    {
      question: "אתה כותב בעצמך את כל הפתרונות לשאלות?",
      answer: "כן. לאחר חקירה מעמיקה על הנושא. אני כותב את הפתרון שהוא 100% שלי."
    },
    {
      question: "איך אתה בוחר את הנושאים לווגים שלך?",
      answer: `תלוי. אם זה שאלה מ leetcode אז אני פשוט משוטט לי באתר. בוחר שאלה שניראת לי מעניינת ומתמקד בה. 
אם זה וולוג - אז כאשר אני קורא על משהו מעניין באינטרנט אני שומר לעצמי את הנושא. וככה אני צובר לי מספר נושאים להתמקד בהם. לפעמים אני מגלה שהנושא לא כ''כ מעניין. ולפעמים אני מגלה שהנושא מורכב ומצריך מספר וולוגים.`
    },
    {
      question: "האם אתה כותב את הוולוגים שלך בעצמך, או שיש לך צוות שעוזר לך?",
      answer: `אני מפתח את כל האתר לבד. נכון שכיף?!`,
    },
    {
      question: "מה התהליך שלך לתכנון והפקת וולוג?",
      answer: `אני קורא שאלה באתר leetcode. ומנסה לפתור את השאלה. לפעמים אני חושב על הפתרון מספר ימים על מנת להגיע לפתרון קריא וברור.`,
    },
    {
      question: "איך אתם שומרים על מוטיבציה ויצירתיות עם תוכן הוולוגים שלכם?",
      answer: `שאלה טובה! פידבק מהאנשים זה המוטיבציה הכי טובה שיש לי.`,
    },
    {
      question: "איזו עצה היית נותן למישהו שרוצה להתחיל לרשום ווג?",
      answer: `לקפוץ למים!! לכתוב כמה וולוגים בודדים ולעלות את האתר לאוויר!! ורק אח''כ להתמקד בהוספת ידע לאתר.`,
    }
  ];


  const title = "קצת עליי ועל הבלוג";
  
  
  return (
    <>      

      <MetaTags
        title="אודות"
        description={title}
        url="/about"
      />
        <Container className="py-5 my-5 text-center rounded responsive-text" style={{ maxWidth: '1000px' }}>
          <Row>
            <Col>
              <h1 className="text-white">{title}</h1>
              
              <div className="n-color-light mt-3">
                <p className="n-color-purple">היי לכולם!</p>
                <p>אני <span className="n-color-purple">נתי</span>, מפתח תוכנה ובלוגר טכנולוגי. אני אוהב לפתור בעיות, בעיקר בתחום <span className="n-color-purple">האלגוריתמים</span>, ולשתף את הידע שלי עם הקהילה.</p>
                <p>האתר הזה הוא המקום שבו אני חולק פתרונות לשאלות הפופולריות ביותר מ-LeetCode, בלוגים על נושאים טכנולוגיים, ותכנים שנוגעים ישירות לעבודה היומיומית של מתכנתים.</p>
                <p>המטרה שלי היא להפוך נושאים מורכבים לפשוטים ונגישים, וגם להראות שלתכנת יכול להיות <span className="n-color-purple">מאתגר – אבל גם מהנה</span>.</p>
                <p>אם יש לכם שאלות, רעיונות, או שסתם בא לכם לדבר – <span className="n-color-purple">אל תהססו ליצור קשר</span>. אני תמיד שמח ללמוד, לשתף ולענות.</p>
                <p><span className="n-color-purple">נתראה בוולוגים!</span> 😊</p>
              </div>
            </Col>
          </Row>
        </Container>

        <div className="container my-5" style={{ maxWidth: '1300px' }}>
          {faqs.map((q, index) => (
            <div className="card mb-3 faq-card" key={index}>
              <div className="card-header">
                <h5 className="faq-question">{q.question}</h5>
              </div>
              <div className="card-body">
                <p className="faq-answer">{q.answer}</p>
              </div>
            </div>
          ))}
        </div>

    </>
  );
};

export default About;
